import utils from '@/mixins/utils.js'

export const dataFieldsPercentual = {
  CNES: 'nu_cnes',
  UBS: 'no_unidade_saude',
  INE: {
    field: 'nu_ine',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
  Microárea: 'micro_area',
  CIDADÃOS: 'cidadaos',
  PERÍODO: {
    field: 'mes_ano',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
  INDICADOR: 'no_indicador',
  PERCENTUAL: {
    field: 'resultado',
    callback: (value) => {
      return value !== '' ? value + '%' : ''
    },
  },
  ATENÇÃO: 'recomendacao_resultado',
}

export const dataFieldsEscore = {
  CNES: 'nu_cnes',
  UBS: 'no_unidade_saude',
  INE: {
    field: 'nu_ine',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
  MICROÁREA: 'micro_area',
  ESCORE: 'escore',
  CLASSIFICAÇÃO: 'classificacao',
}

export const dataFieldsEscorePrevistoRealizado = {
  CNES: 'nu_cnes',
  UBS: 'no_unidade_saude',
  INE: {
    field: 'nu_ine',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
  MICROÁREA: 'micro_area',
  'ESCORE PREVISTO': {
    field: 'escore_previsto',
    callback: (value) => {
      return value != null ? `​  ​​${value}` : ''
    },
  },
  'ESCORE REALIZADO': {
    field: 'escore_realizado',
    callback: (value) => {
      return value != null ? `​  ​​${value}` : ''
    },
  },
  'CLASSIFICAÇÃO PREVISTA': 'classificacao_prevista',
  'CLASSIFICAÇÃO REALIZADA': 'classificacao_realizada',
}

export const optionsIndicador = [
  { label: 'CI atualizado', value: 0 },
  { label: 'CDT atualizado e 100% completo', value: 31 },
  { label: 'CI e CDT atualizados e 100% completos', value: 32 },
  { label: 'CI 100% completo', value: 27 },
  { label: 'CI atualizado e 100% completo', value: 28 },
  { label: 'CI atualizado e 91% ou + completo', value: 29 },
  { label: 'Pessoas acompanhadas na APS', value: 30 },
  { label: 'CI e CDT atualizados', value: 33 },
]

export const infoHtml = `
`
